import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-signup',
  templateUrl: './home-signup.component.html',
  styleUrls: ['./home-signup.component.scss'],
})
export class HomeSignupComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
